import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {AssessmentNarrativeDTO} from '../models/AssessmentNarrativeDTO';

@Injectable({
  providedIn: 'root'
})
export class AssessmentNarrativeService {

  private url = environment.baseClmUrl + '/assessment-narrative';

  constructor(private httpClient: HttpClient) {
  }

  saveAssessmentNarrative(assessmentNarrativeDTO: AssessmentNarrativeDTO): Observable<AssessmentNarrativeDTO> {
    return this.httpClient.post<AssessmentNarrativeDTO>(this.url, assessmentNarrativeDTO);
  }
}
